import { axiosAjax } from '@app/src/config/axios';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';
import { getSettings } from '@app/src/configuration/config.service';

export const serviceEditUser = {
  async getData(values: object, url: string, refreshToken?: string) {
    try {
      const accessToken = refreshToken ? refreshToken : sessionStorage.getItem('accessToken');
      delete values['email']
      const { data } = await axiosAjax.put(url, { payload: values }, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return data.data;
    } catch (e) {
      throw e.response.data;
    }
  }
}

export const serviceRefreshToken = {
  async getData(refreshToken) {
    try {
      const expToken = sessionStorage.getItem('accessToken');
      const { data, headers } = await axiosAjax.post(getSettings().API_REFRESH_TOKEN, { refreshToken, expToken });
      const refreshtoken = headers.authorization;
      localStorage.setItem('refreshtoken', refreshtoken);
      if(data.code == 100){
        sessionStorage.setItem('accessToken', data.data.accessToken);
        sessionStorage.setItem('reportToken', data.data.reportToken);
        return data;
      }else{
        throw new Error(data.message);
      }
    } catch (e) {
      throw e.response.data;
    }
  }
}
